const sectionReviewGridCss = `
[data-type='section-review-grid'] [data-attribute='review-grid-container'] {
  padding: 40px 0;
}

[data-type='section-review-grid'] [data-attribute='review-grid-container'] .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

[data-type='section-review-grid'] [data-attribute='review-grid-container'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-review-grid'] [data-attribute='review-grid-container'] .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

[data-type='section-review-grid'] .wrap-review-grid {
  overflow-y: hidden;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

[data-type='section-review-grid'] .wrap-review-grid::-webkit-scrollbar {
  display: none;
}

[data-type='section-review-grid'] .wrap-review-grid .header-review {
  text-align: center;
  margin-bottom: 40px;
}

[data-type='section-review-grid'] .wrap-review-grid .header-review .title-review {
  margin-bottom: 40px;
  text-align: center;
  font-size: 24px;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review {
  width: 100%;
  max-width: 100%;
  position: relative;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review {
  display: flex;
  flex-direction: column;
  height: auto;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card {
  background: #f6f6f6;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px !important;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-avatar {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #e0e0e0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-avatar::before {
  content: '';
  font-size: 24px;
  color: #999;
  position: absolute;
  z-index: 1;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  z-index: 2;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details {
  flex: 1;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .reviewer-name {
  font-size: 18px;
  font-weight: bold !important;
  margin: 0 0 8px 0 !important;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .wrap-stars {
  display: flex;
  gap: 4px;
  color: #c4c4c4;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .wrap-stars svg {
  fill: #c4c4c4;
  width: 20px;
  height: 20px;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .review-content {
  margin-bottom: 20px !important;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .review-content p {
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: all 0.3s ease;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .review-content.expanded p {
  -webkit-line-clamp: unset !important;
  line-clamp: unset !important;
  overflow: visible;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .show-more-btn {
  background: #000;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 6px 16px;
  font-size: 12px;
  cursor: pointer;
  font-weight: 500;
  align-self: flex-start;
  transition: all 0.3s ease;
}

[data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .show-more-btn:hover {
  opacity: 0.8;
}

@container (max-width: 768px) {
  [data-type='section-review-grid'] [data-attribute='review-grid-container'] {
    padding: 16px 0;
  }

  [data-type='section-review-grid'] .wrap-review-grid .header-review {
    margin-bottom: 32px;
  }

  [data-type='section-review-grid'] .wrap-review-grid .header-review .title-review {
    font-size: 20px;
    margin-bottom: 12px;
  }

  [data-type='section-review-grid'] .wrap-review-grid .body-review {
    padding-bottom: 30px;
  }

  [data-type='section-review-grid'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-info .reviewer-details .reviewer-name {
    font-size: 16px;
  }
}
`;

export default sectionReviewGridCss;
